import { createContext, ReactNode, useContext } from "react";
import { useParams } from "react-router-dom";

interface RouteContextType {
    params: Record<string, string | undefined>;
}

export const PreloadCompatibleRouteContext = createContext<RouteContextType>({
    params: {}
});

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
export function usePreloadCompatibleRouteParams<T>(): T {
    return useContext(PreloadCompatibleRouteContext).params as T;
}

export const PreloadCompatibleRouteProvider = ({
    children
}: {
    children: ReactNode;
}) => {
    const params = useParams();

    return (
        <PreloadCompatibleRouteContext.Provider value={{ params }}>
            {children}
        </PreloadCompatibleRouteContext.Provider>
    );
};
